const homeInteriorFAQData = [
    {
      question: "What is the process for a home interior design project?",
      answer: "Our process typically involves an initial consultation, site visit, concept development, design presentation, and final execution. We work closely with you at each stage to ensure your vision is realized.",
    },
    {
      question: "How long does a typical interior design project take?",
      answer: "The timeline varies depending on the scope and complexity of the project. Generally, a full home interior design project can take anywhere from a few weeks to several months.",
    },
    {
      question: "Do you provide 3D visualizations?",
      answer: "Yes, we provide 3D visualizations to help you better understand and visualize the proposed design before implementation.",
    },
    {
      question: "Can you work within my budget?",
      answer: "Absolutely. We work with various budgets and strive to provide the best possible design solutions within your financial parameters. We'll discuss your budget in detail during the initial consultation.",
    },
    {
      question: "Do you handle the procurement of furniture and materials?",
      answer: "Yes, we handle the procurement of furniture, fixtures, and materials, ensuring quality and timely delivery. We have established relationships with various suppliers and vendors.",
    },
    {
      question: "What styles of interior design do you specialize in?",
      answer: "We specialize in a wide range of interior design styles, including modern, contemporary, minimalist, traditional, and eclectic. We tailor our designs to your personal taste and preferences.",
    },
    {
      question: "Do you offer consultations for specific rooms or areas of the house?",
      answer: "Yes, we offer consultations for specific rooms or areas of the house, as well as full home interior design projects. Whether you need help with a single room or an entire home, we're here to assist.",
    },
    {
      question: "How do you ensure the design aligns with my personal style?",
      answer: "We begin with an in-depth consultation to understand your preferences, lifestyle, and vision. We gather inspiration from your ideas and create a design that reflects your unique style.",
    },
    {
      question: "Do you provide project management services?",
      answer: "Yes, we provide comprehensive project management services to oversee the entire renovation process, ensuring that the project is completed on time and within budget.",
    },
    {
      question: "What happens if I want to make changes after the design is finalized?",
      answer: "We understand that changes may be necessary. We allow for revisions within reason, and we'll work with you to accommodate your needs while keeping the project on track.",
    },
  ];
  
  export default homeInteriorFAQData;